import React, { useEffect } from 'react'
import { Button } from '@mui/material'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import VerdictScreen from './scanner/VerdictScreen'
import { playInvalidSound } from '../services/soundService'

const ErrorScanResponse = ({ message, onCancel }) => {
  // Cet écran n'est rendu que sur un refus : le signal accompagne son affichage.
  useEffect(() => {
    playInvalidSound()
  }, [])

  return (
    <VerdictScreen
      status="invalid"
      title="Invalide"
      message={message}
      footer={
        <Button
          fullWidth
          variant="contained"
          size="large"
          startIcon={<QrCodeScannerIcon />}
          onClick={onCancel}
        >
          Billet suivant
        </Button>
      }
    />
  )
}

export default ErrorScanResponse
